import React from 'react';
import { Box, Divisor } from 'components';
import type { ShipmentQuoteAppT } from 'apps/shipmentQuote/app';

import { DetailsSection } from './DetailsSection';
import { PriceSection } from './PriceSection';

type PropsT = {
  quote: ShipmentQuoteAppT;
};

export const ShipmentQuoteDetails = ({ quote }: PropsT) => {
  if (!quote) return null;
  return (
    <Box mt={8} sx={{ display: 'flex' }}>
      <DetailsSection quote={quote} />
      <Divisor variant='vertical' />
      <PriceSection quote={quote} />
    </Box>
  );
};
